export interface SharedNotesAccessContext {
  sharedNotesEnabled: boolean;
  canSeeNotes: boolean;
  canEditNotes: boolean;
  isSystemSession: boolean;
}

// Shared notes have no product requirement for system-session visibility; revisit if one appears.
export const canAccessSharedNotes = (ctx: SharedNotesAccessContext): boolean =>
  !ctx.isSystemSession && ctx.sharedNotesEnabled && (ctx.canSeeNotes || ctx.canEditNotes);
